import { TableInlineColumn, TableInlines } from 'components';
import { ReactElement } from 'react';
import { ActivityType } from 'types';
import { ServiceRate } from './types';
import { DecimalField, TextField } from '@ff-it/form';
import { CategoryField } from 'modules/supplier/category/MediaCategoryField';
import { SupplierField } from 'modules/supplier/supplier/components';
import { Box } from '@ff-it/ui';
import { required } from 'utilities';

const initialValues = {
  target_supplier: {
    provider: null,
    activity: null,
    product: null,
  },
  target_category: null,
  client_price: null,
  terms: '',
};

export function SeviceRates({ type }: { type: ActivityType }): ReactElement {
  const columns: TableInlineColumn<ServiceRate>[] = [
    {
      key: 'client_price',
      content: 'Client price',
      render: ({ name }) => {
        return <DecimalField name={`${name}.client_price`} className="mb-0" required validate={required} />;
      },
      width: '120px',
    },

    {
      key: 'target_category',
      content: 'Target category',
      render: ({ name }) => <CategoryField name={`${name}.target_category`} className="mb-0" />,
    },
    {
      key: 'target_supplier',
      content: 'Target supplier fields',
      render: ({ name }) => (
        <SupplierField name={`${name}.target_supplier`} className="mb-0" type={type} kind="SERVICE" partial />
      ),
    },
    {
      key: 'terms',
      content: 'Comment',
      render: ({ name }) => <TextField multiline name={`${name}.terms`} className="mb-0" />,
    },
  ];

  return (
    <Box testId="service-rates" mb="5">
      <Box display="flex" alignItems="center" fontWeight="semibold">
        Service rates
        <Box marginLeft="auto" fontWeight="regular" fontSize="xs">
          Set client price when target conditions are met.
        </Box>
      </Box>
      <TableInlines name="service_rates" initialValues={initialValues} columns={columns} />
    </Box>
  );
}
